export default __webpack_public_path__ + "static/media/audifront.2c81e0d4.jpg";